export const TOKEN_STORAGE_KEY = 'hea_auth_token';
export const USERNAME_STORAGE_KEY = 'hea_auth_username';

export const AUTH_ROUTES = {
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  HOME: '/',
} as const;
